import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useFont } from "../contexts/FontContext";
import Page from "../Components/Page";
import HomeButton from "../Components/HomeButton";

const DigitalLibrary = () => {
  const fontValue = useFont();
  const font = fontValue?.font;

  const [, setError] = useState(null);
  const [assetsData, setAsestsData] = useState([]);
  const [newsLetterData, setNewsLetterData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [password, setPassword] = useState("");
  const [fileName, setFilename] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_STRAPI_API_URL +
          "/api/dadl?populate[DADL_NEWSLETTERS][populate][DADLCTG_1IMG]=*&populate[DADL_NEWSLETTERS][populate][DADL_PDF]=*&populate[DADL_PROD_BROCH][populate][DADLCTG_1IMG]=*&populate[DADL_PROD_BROCH][populate][DADL_PDF]=*"
      )
      .then(({ data }) => {
        setAsestsData(data.data);
        setNewsLetterData(data.data.attributes?.DADL_NEWSLETTERS);
      })
      .catch((error) => setError(error));
  }, []);

  const openFileFromStrapi = async (passwordSend, filename) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_STRAPI_API_URL + "/api/secureFiles",
        {
          password: passwordSend,
          fileName: filename,
        },
        { responseType: "blob" }
      );

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl);
      setShowPopup(false);
      setPassword("");
      setLoading(false);
    } catch (error) {
      setShowPopup(true);
      if (error.response) {
        switch (error.response.status) {
          case 400:
            alert("Invalid input");
            break;
          case 401:
            alert("Incorect iassword");
            break;
          case 500:
            alert("File not found");
            break;
          default:
            alert("An unknown error occurred");
        }
      }

      setLoading(false);
    }
  };

  const togglePopup = (filename) => {
    setShowPopup(!showPopup);
    setFilename(filename);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === "") {
      alert(`Password empty`);
    } else {
      setLoading(true);
      openFileFromStrapi(password, fileName);
    }
  };

  return (
    <Page isLoading={fontValue?.loading}>
      <div className="bg-gray-300 min-h-screen">
        <div className="lg:max-w-[1100px] m-auto">
          <div className="flex justify-center pt-10 pb-10">
            <p className={`${font?.SUHTX} text-black text-center`}>
              {assetsData.attributes?.DADLHTX_1}
            </p>
          </div>
          {newsLetterData && (
            <>
              <p className={`${font?.SUHTX} text-black pl-2`}>
                {assetsData.attributes?.DADLCTGHTX_1?.split(/\n/).map(
                  (line) => (
                    <span key={`DADLCTGHTX_1$${line}`}>
                      {line} <br />
                    </span>
                  )
                )}
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-4 pt-4 pb-10 pr-2 pl-2">
                {newsLetterData?.map((newsLetter) => (
                  <div key={newsLetter.DADLCTGSHTX_1A}>
                    <div className=" shadow-lg bg-[#DD8732] h-auto min-w-fit">
                      <div className="flex items-center ">
                        <div className={`${font?.HTX} text-black p-4 w-full`}>
                          {newsLetter.DADLCTGSHTX_1A}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center bg-white">
                      <img
                        src={
                          process.env.REACT_APP_STRAPI_API_URL +
                          newsLetter.DADLCTG_1IMG.data?.attributes.url
                        }
                        alt="img"
                        className="w-auto h-72 m-4"
                      />
                    </div>
                    <div className="bg-white">
                      {newsLetter.DADLCTGSDTX_1A && (
                        <p className={`${font?.DTX} text-black p-2`}>
                          {newsLetter.DADLCTGSDTX_1A?.split(/\n/).map(
                            (line) => (
                              <span key={`DADLCTGSDTX_1A$${line}`}>
                                {line} <br />
                              </span>
                            )
                          )}
                        </p>
                      )}
                      <div className="flex pt-2 pb-2 justify-end">
                        <button
                          className={`${font?.DTX} bg-gradient-to-r from-[#FFCB00] to-[#F48B00] rounded-3xl pl-3 pr-3 mr-4`}
                          onClick={() => togglePopup(newsLetter.DADLCTGSHTX_1A)}
                        >
                          Download
                        </button>
                        {showPopup && (
                          <div>
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                              <div className={`bg-white p-6  `}>
                                <div>
                                  <div
                                    className={`${font?.HTX} text-black  w-full`}
                                  >
                                    Important Notice
                                  </div>
                                  <p className={`${font?.DTX} pb-2`}>
                                    This document is password protected. Please
                                    email 
                                    <a
                                      className="text-[#F48B00]"
                                      href="mailto:lifesbetter@newbos.com"
                                    >
                                      lifesbetter@newbos.com
                                    </a>
                                     for credentials.
                                    <br /> To access our resources, please
                                    ensure that your pop-up blocker is disabled
                                    or add an exception
                                    <br /> for this site. Depending on the file
                                    size, the download may take a few moments.
                                    Thank you for <br />
                                    your patience.
                                  </p>
                                  <h2 className={`${font?.SUHTX} mb-2`}>
                                    Enter Password
                                  </h2>

                                  <form onSubmit={handleSubmit}>
                                    <input
                                      type="password"
                                      value={password}
                                      onChange={handlePasswordChange}
                                      placeholder="Enter your password"
                                      required
                                      className={`${font?.DTX} bg-gray-200 border-2 border-gray-200 p-2 rounded-full w-full mb-4 focus:outline-none focus:bg-white focus:border-[#DD8732]`}
                                    />
                                    <div className="flex justify-between">
                                      {loading === true ? (
                                        <button
                                          type="button"
                                          className={`${font?.DTX} flex bg-gradient-to-r from-[#FFCB00] to-[#F48B00] rounded-3xl py-2 px-4`}
                                          disabled
                                        >
                                          <svg
                                            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                          >
                                            <circle
                                              className="opacity-25"
                                              cx="12"
                                              cy="12"
                                              r="10"
                                              stroke="currentColor"
                            strokeWidth="4"
                                            ></circle>
                                            <path
                                              className="opacity-75"
                                              fill="currentColor"
                                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            ></path>
                                          </svg>
                                          Processing...
                                        </button>
                                      ) : (
                                        <button
                                          type="submit"
                                          className={`${font?.DTX} bg-gradient-to-r from-[#FFCB00] to-[#F48B00] rounded-3xl py-2 px-4`}
                                        >
                                          Submit
                                        </button>
                                      )}
                                      <button
                                        className={`${font?.DTX} bg-gradient-to-r from-[#FFCB00] to-[#F48B00] rounded-3xl py-2 px-4`}
                                        onClick={togglePopup}
                                        disabled={loading === true}
                                      >
                                        Close
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="h-2 bg-[#DD8732]"></div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <HomeButton />
    </Page>
  );
};

export default DigitalLibrary;
